@if (loading()) {
  <app-loading />
} @else {
  <app-step-dot-menu
    [projectId]="projectId()!"
    testId="step2-1-dot-menu-button"
    [preselectedRole]="ProjectRoleType.CONTRIBUTOR"
    [preselectedAccessiblePages]="[ProjectStepType.DESIGN_CRITERIA]"
  ></app-step-dot-menu>

  <div class="card mt-5" data-testid="design-criteria-page">
    <app-card-title key="project.steps.predefinedCriteriaTitle" />

    <app-badge-list
      [items]="badgeListItems()"
      [headerInputTemplate]="headerInputTemplate"
      [contentTemplate]="contentTemplate"
    >
      <ng-template #headerInputTemplate let-item>
        <div>
          <app-model-field-select-inclusion
            [id]="'criteria-toggle-btn-' + item.key"
            [value]="item.originalItem.isIncluded"
            (valueChange)="onIncludeToggle(item.key, $event!)"
            [isReadOnly]="isCriteriaDisabled(item.key) || isButtonDisabled()"
          />
        </div>
      </ng-template>

      <ng-template #contentTemplate let-item>
        <p class="m-0" [attr.data-testid]="'criteria-description-' + item.key">
          {{ item.translations | directusTranslation: currentLang : '' : 'description' }}
        </p>
      </ng-template>
    </app-badge-list>

    <app-audit-info [auditInfo]="auditInfo()" />
  </div>
}
